import {html, LitElement} from "@isceco/widget-library2/external/lit";
import TileGroupCss from './TileGroupCss.js'

export class TileGroup extends LitElement {

  static get styles() {
    return [TileGroupCss]
  }

  render() {
    return html`
      <slot></slot>
    `
  }
}
customElements.define('eko-tile-group', TileGroup)
